import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { COMMON_LOADING_STATES, GENERIC_ERROR_MESSAGE, PAGE_STATE } from "../../../constants/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { componentKey, set1099FormsGrid, setApproveFormsModal, setDownloadAllPDFModal, setFormsList, setLoadingState, setPaginationState, setPayersList, setRejectFormsModal, setSelected1099FormsGrid, setSelectedForm, setSelectedPayer, setSelectedStatus, setSelectedTaxYear, setStatusList, setTaxYears } from "./Forms1099Slice";
import General from "../../../../../libs/utility/General";
import RightsManagementDataService from "../../../../../services/RightsManagementDataService";
import FormsDataService from "../../../../../services/FormsDataService";
import Forms from "../../../../../libs/utility/formsutility/Forms";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { setRejectFormRemark } from "./Forms1099Slice";
import { REVIEW_AND_APPROVE_FORMS_LOADING_STATES, REVIEW_APPROVE_FORMS_LOADING_STATES } from "../constants";

export const { get1099FormStatuses, getFormsListAndTaxYears, getReviewApprovePayers, reviewAndApproveGridData, reviewApproveFormsDownloadAllPDF, reviewApproveFormsExportToExcel, downloadMultiplePDF, viewPDF, rejectForm, approveForm } = {

    get1099FormStatuses: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/GET_1099_STATUSES",
            payload
        }
    },

    getFormsListAndTaxYears: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/GET_FORMS_AND_TAX_YEARS",
            payload
        }
    },

    getReviewApprovePayers: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/GET_PAYERS",
            payload
        }
    },

    reviewAndApproveGridData: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/GET_GRID_DATA",
            payload
        }
    },

    reviewApproveFormsDownloadAllPDF: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/DOWNLOAD_ALL_PDF",
            payload
        }
    },

    reviewApproveFormsExportToExcel: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/EXPORT_TO_EXCEL",
            payload
        }
    },

    downloadMultiplePDF: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/DOWNLOAD_MULTIPLE_PDF",
            payload
        }
    },

    viewPDF: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/VIEW_PDF",
            payload
        }
    },

    rejectForm: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/REJECT_FORM",
            payload
        }
    },

    approveForm: (payload) => {
        return {
            type: "REVIEW_APPROVE_FORMS/APPROVE_FORM",
            payload
        }
    }

}

function* get1099FormStatusesAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_LOADING }));

        const { status } = action?.payload;

        const response = yield RightsManagementDataService.reviewAndApproveStatuses();
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            General.addOptionAndValueKeys(Data, "status", "statusId")

            if (status) {
                const tmpStatus = Data.find(r => r.status == status);

                if (tmpStatus) {
                    yield put(setSelectedStatus(tmpStatus));
                }
            }

            yield put(setStatusList(Data))

        } else {
            yield put(addNotifications({ heading: "Failed to fetch the status list", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch the status list", message: GENERIC_ERROR_MESSAGE }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_READY }))
    }
}

function* getFormsListAndTaxYearsAsync(action) {

    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));

        const { formId = "", taxYear } = action.payload;

        const response = yield FormsDataService.getFormsList();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const formList = [...Data.Forms];
            General.addOptionAndValueKeys(formList, "FormLabel", "Id")

            yield put(setFormsList(formList));


            if (formId) {
                const form = formList.find(form => form.Id == formId);

                if (form) {
                    yield put(setSelectedForm(form))
                }
            }

            // Setting tax year
            const yearsList = Data.Years.map(year => {
                return { label: `${year}`, value: year }
            });

            yield put(setTaxYears(yearsList));

            if (taxYear) {
                const year = yearsList.find(year => year.value == taxYear);
                if (year) {
                    yield put(setSelectedTaxYear(year));
                }
            }

        } else {
            yield put(addNotifications({ heading: "Failed to fetch forms list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch forms list", message: GENERIC_ERROR_MESSAGE }));
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }

}

function* getReviewApprovePayersAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }));

        const { formId, payerId, paginationState, taxyear, formstatus } = action.payload;

        const params = { formId }
        const response = yield RightsManagementDataService.reviewAndApprovePayers(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const payersList = [...Data];
            General.addOptionAndValueKeys(payersList, "LastName", "PayerDetailId");

            yield put(setPayersList(payersList));

            if (payerId) {
                const payer = payersList.find(payer => payer.value == payerId);

                if (payer) {
                    yield put(setSelectedPayer(payer));
                }

                if (formId && taxyear && payerId && formstatus) {
                    yield put(reviewAndApproveGridData({ paginationState, formId, taxyear, payerId, formstatus }))
                }
            }

        } else {
            yield put(addNotifications({ heading: "Failed to fetch payers", message: Message }));
        }
    }
    catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch the payers list", message: GENERIC_ERROR_MESSAGE }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* reviewAndApproveGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }));

        const { paginationState, formId, taxyear, payerId, formstatus } = action?.payload;

        const params = {
            PageSize: paginationState?.PageSize || 10,
            PageNumber: paginationState?.PageNumber || 1,
            formId,
            taxyear,
            payerId,
            formstatus,
            FilterText: "",
            IdNumber: "",
            IsDesc: false
        };

        const response = yield RightsManagementDataService.reviewAndApproveGridData(params);
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            yield put(set1099FormsGrid(Data));
            yield put(setPaginationState({ ...paginationState, total: Data?.Total || Data.length }))
        } else {
            yield put(setSelected1099FormsGrid([]));
            yield put(setPaginationState({ ...paginationState, total: 0 }))
            yield put(addNotifications({ heading: "Failed to fetch the grid data", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch the grid data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* reviewApproveFormsDownloadAllPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING }))

        const { payerId, formName, taxYear, formList, selectedFormList, payerName, mergeCopies } = action.payload

        const data = {
            jsonPreferences: Forms.getJsonPreferences(formList, selectedFormList, formName),
            payerName: payerName,
            payerId: payerId,
            ReferenceNo: null,
            partNumber: null,
            maskTin: false,
            pdfCopy: "payee",
            formName: formName,
            taxYear: parseInt(taxYear),
            sourcePage: "Submit",
            isCorrected: false,
            mergeCopies: mergeCopies || false
        }

        const response = yield SubmitFormsDataService.createZipForDownloadAll(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(downloadMultiplePDF({ fileName: Data.EncryptedPayerName, formName: Data.FormName }));
        } else {
            yield put(addNotifications({ heading: "Failed to download PDF", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setDownloadAllPDFModal(false));
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_READY }))
    }
}

function* downloadMultiplePDFAsync(action) {

    try {
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING }))

        const { fileName, formName } = action.payload

        const response = yield SubmitFormsDataService.downloadMultiplePDF(fileName, formName);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to download pdf", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_READY }))
    }

}

function* reviewApproveFormsExportToExcelAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))

        const { payerId, formId, taxyear, status, formName } = action.payload

        const params = {
            payerId,
            formId,
            taxyear: Number(taxyear),
            formName,
            statusType: "NotSubmitted",
            status: "Not Submitted",
            formtype: ""
        }

        const response = yield RightsManagementDataService.reviewApproveExport(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to download the sheet", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download the sheet", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* viewPDFAsync(action) {
    try {
        const { formId, payerId, formTypeId } = action.payload
        
        yield put(setLoadingState({ state: `${REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${formId}` }))

        const data = {
            formId,
            PayerId: payerId,
            formTypeId: formTypeId,
            isUnMask: false,
            employerId: 0
        }

        const response = yield SubmitFormsDataService.downloadSinglePDF(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to open the PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LIST_READY }))
    }
}

function* rejectFormAsync(action) {

    try {
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_LOADING }));

        const { formIds, payerId, formName, payerName, taxyear, remarks, paginationState, formId, formstatus } = action.payload;

        const params = {
            formIds,
            payerId,
            formName,
            payerName,
            taxyear,
            remarks
        };

        const response = yield RightsManagementDataService.reviewApproveRejectForms(params);

        const { Status, Message, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Form(s) Rejected Successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(reviewAndApproveGridData({ paginationState, formId, taxyear, payerId, formstatus }))
        } else {
            yield put(addNotifications({ heading: "Failed to reject the form", message: Message }));
        }

    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to reject the form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setRejectFormsModal(false))
        yield put(setRejectFormRemark(""))
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_READY }))
    }
}

function* approveFormAsync(action) {

    try {
        yield put(setApproveFormsModal(false))
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.APPROVE_POPUP_LOADING }));

        const { formIds, payerId, formName, payerName, taxyear, paginationState, formId, formstatus } = action.payload;

        const params = {
            formIds,
            payerId,
            formName,
            payerName,
            taxyear
        };

        const response = yield RightsManagementDataService.approveForms(params);
        const { Status, Message, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Form(s) Reviewed & Approved Successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(reviewAndApproveGridData({ paginationState, formId, taxyear, payerId, formstatus }))
        } else {
            yield put(addNotifications({ heading: "Failed to approve the form", message: Message }));
        }

    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to approve the form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.APPROVE_POPUP_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(get1099FormStatuses().type, get1099FormStatusesAsync),
        takeLatest(getFormsListAndTaxYears().type, getFormsListAndTaxYearsAsync),
        takeLatest(getReviewApprovePayers().type, getReviewApprovePayersAsync),
        takeLatest(reviewAndApproveGridData().type, reviewAndApproveGridDataAsync),
        takeLatest(reviewApproveFormsDownloadAllPDF().type, reviewApproveFormsDownloadAllPDFAsync),
        takeLatest(reviewApproveFormsExportToExcel().type, reviewApproveFormsExportToExcelAsync),
        takeLatest(downloadMultiplePDF().type, downloadMultiplePDFAsync),
        takeLatest(viewPDF().type, viewPDFAsync),
        takeLatest(rejectForm().type, rejectFormAsync),
        takeLatest(approveForm().type, approveFormAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);